export const COLORS = ['#E91E63', '#9C27B0', '#3F51B5', '#2196F3', '#4CAF50', '#FF9800', '#795548'];

export const EXPENSE_TYPES = [
  { value: 'school_fees', label: 'School Fees' },
  { value: 'school_uniform', label: 'School Uniform' },
  { value: 'school_shoes', label: 'School Shoes' },
  { value: 'sports_wear', label: 'Sports Wear' },
  { value: 'shoes', label: 'Shoes' },
  { value: 'sanitary_products', label: 'Sanitary Products' },
  { value: 'animals', label: 'Animals' },
  { value: 'medical_checkup', label: 'Medical Check-up' },
  { value: 'school_tour', label: 'School Tour' },
  { value: 'remedial_classes', label: 'Remedial Classes' },
  { value: 'stationery', label: 'Stationery' },
  { value: 'medicare', label: 'Medicare' },
  { value: 'food', label: 'Food' },
  { value: 'other', label: 'Other' },
];

export const BULK_BILL_CATEGORIES = [
  { value: 'school_fees', label: 'School Fees' },
  { value: 'school_uniform', label: 'School Uniform' },
  { value: 'school_shoes', label: 'School Shoes' },
  { value: 'sports_wear', label: 'Sports Wear' },
  { value: 'shoes', label: 'Shoes' },
  { value: 'sanitary_products', label: 'Sanitary Products' },
  { value: 'animals', label: 'Animals' },
  { value: 'medical_checkup', label: 'Medical Check-up' },
  { value: 'school_tour', label: 'School Tour' },
  { value: 'remedial_classes', label: 'Remedial Classes' },
];
